<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <preLoader v-if="loader"></preLoader>
        <div class="container">

            <div class="form-group" style="margin-top: 30px">
                <router-link to="/services" class="btn btn-default">{{ $t('Back') }}</router-link>
            </div>

            <div class="panel panel-default">
                <div class="panel-heading">{{ $t('Edit') }} </div>
                <div class="panel-body">
                    <form v-on:submit.prevent="saveForm()">





                        <!--<ul v-if="errors && errors.length" class="container ">-->
                        <!--<li v-for="error of errors[0]" class="text-danger" >-->

                        <!--<ul >-->
                        <!--<li v-for="error_message of error" class="text-danger" >-->
                        <!--{{error_message}}-->
                        <!--</li>-->
                        <!--</ul>-->

                        <!--<hr>-->


                        <!--</li>-->
                        <!--</ul>-->



                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Assortment') }} </label>


                                <select class="form-control" v-model='item.service_categories_id'>
                                    <option v-for="service_category in service_categories" :key="service_category.id" :value="service_category.id">
                                        <!-- here -->
                                        {{service_category.title}}
                                    </option>
                                </select>



                                <!--
                            v-on:change='getCities(selectedCountry.rid)'
                            <option  v-for="service_category of service_categories"  value="{{service_category.id}}">{{service_category.title}}</option>-->

                            
                            </div>
                        </div>







                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"> {{ $t('Title') }} </label>
                                <input type="text" v-model="item.title" class="form-control">
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">Code</label>
                                <input type="text" v-model="item.coce" class="form-control">

                            </div>
                        </div>
                        <!--<div class="row">-->
                        <!--<div class="col-xs-12 form-group">-->
                        <!--<label class="control-label">تصویر</label>-->
                        <!--<input type="text" v-model="item.image" class="form-control">-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Description') }}</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>
                          <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Score') }} </label>
                                <input type="text" v-model="item.score" class="form-control">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Image') }} </label>
                                <div class="form-group">
                                    <div class="input-group input-file" name="Fichier1">
                                        <input type="text" class="form-control" :placeholder="placeholder" />
                                        <input type="file" class="filestyle" ref="file"
                                            @change="onFileChange($event)" />
                                        <span class="input-group-btn">
                                            <button class="btn btn-default btn-choose" type="button"> {{ $t('File') }}</button>
                                        </span>


                                    </div>
                                </div>
                            </div>
                        </div>
<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label">تعداد ارائه خدمت</label>-->
<!--                                <input type="text" v-model="item.initial_number" class="form-control">-->
<!--                            </div>-->
<!--                        </div>-->

                        <!--<div class="row">-->
                        <!--<div class="col-xs-12 form-group">-->
                        <!--<label class="control-label">شهر</label>-->
                        <!--<select v-model="item.city"  class="form-control">-->
                        <!--<option selected value="1">تهران</option>-->
                        <!--<option value="1">کرج</option>-->
                        <!--<option value="1">اصفهان</option>-->
                        <!--<option value="1">اهواز</option>-->
                        <!--<option value="1">مشهد</option>-->
                        <!--<option value="1">تبریز</option>-->
                        <!--</select>-->
                        <!--</div>-->
                        <!--</div>-->

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"> {{ $t('Default price') }}({{$curency}})</label>
                                <input class="form-control" v-model="item.price" id="id_step2-number_2"
                                    name="step2-number_2" type="text" data-type="number">

                            </div>
                        </div>


<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label">{{ $t('Minimum time') }}({{ $t('min') }})</label>-->
<!--                                <input type="text" v-model="item.min_time" class="form-control">-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label"> {{ $t('Maximum time') }}({{ $t('min') }})</label>-->
<!--                                <input type="text" v-model="item.max_time" class="form-control">-->
<!--                            </div>-->
<!--                        </div>-->


                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <button class="btn btn-success">{{ $t('Edit') }}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // const auth = {
    //     headers: {
    //         Authorization: 'bearer ' + localStorage.getItem('token')
    //     }
    // };


    export default {

        mounted() {
            let app = this;
            app.loader = true
            let id = app.$route.params.id;
            app.itemId = id;
            axios
                .get('/api/services/' + id, app.auth)
                .then(function (resp) {
                    app.item = resp.data.data;
                    app.loader = false
                })
                .catch(function () {
                    alert("بارگذاری دسته بندی ها امکان پذیر نیست");
                    //                    console.log('a: ' + auth)
                });



            axios
                .get('/api/serviceCategorieslist', app.auth)
                .then(function (resp) {
                    app.service_categories = resp.data;
                })

                .catch(function (e) {
                    app.errors.push(e.response.data.messages_fa);

                    //                            app.$snotify.warning(e.response.data.message);
                    console.log(e.response.data);


                    for (let value of e.response.data.messages_fa) {
                        //                        for (let error of Object.entries(value[1])) {
                        //                            console.log(app.object.entries(app.errors[0]));

                        app.$snotify.warning(value, {
                            timeout: 7000,
                            //                                    showProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true
                        });

                        //                        }
                    }

                });




            this.spliceNumber('1')


        },
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token'),
                        //  headers: {
                            // 'Content-Type': 'multipart/form-data'
                            'Content-Type': 'application/x-www-form-urlencoded'
                        // }
                    }
                },
                itemId: null,
                placeholder: "فایل را انتخاب کنید...",
                item: {
                   
                    service_categories_id: '1',
                    title: '',
                    description: '',
                    initial_number: '',
                    price: '',
                    tax: 0,
                    min_time: '',
                    max_time: '',
                    image: '',
                    score: ''


                },
                loader: false,
                errors: [],
                service_categories: []

            }
        },


        methods: {
            onFileChange(e) {

                //    console.log(e.target.files[0])
                this.item.image = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.item.image, "144")

            },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").focus(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            },
            saveForm() {
                var app = this;
                var newItem = app.item;
                app.loader = true
                let formData = new FormData();
                formData.append("_method","PATCH")
                //  formData.append(key, element)
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        if(element !== null)
                        formData.append(key, element)
                        // console.log(key, element);
                    }
                }
                console.log(formData, "44")
                axios.post('/api/services/' + app.itemId, formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success('آیتم با موفقیت ذخیره شد');
                        app.loader = false
                        app.$router.replace('/service/list');
                    }.bind(this))
                    .catch(function (e) {
                        app.loader = false
                        app.errors.push(e.response.data.messages);

                        //                            app.$snotify.warning('اطلاعات به درستی وارد نشده است');
                        //                            console.log(Object.entries(this.errors[0]));

                        for (let value of Object.entries(app.errors[0])) {

                            app.$snotify.warning(value[1], {
                                timeout: 7000,
                                showProgressBar: false,
                                //                                        closeOnClick: false,
                                pauseOnHover: true
                            });

                        }
                    });
            }
        }
    }

</script>
<style>
    .filestyle {
        width: 100%;
        position: absolute;
        height: 100%;
        z-index: 1111;
        opacity: 0;
    }

</style>
